
export default function PlanFormScheduleDirective() {
    return {
        restrict: 'E',
        template: require('./schedule.html'),
        scope: {
            plan: '=',
            edit: '='
        },
        controller: function ($scope, gettextCatalog) {

            'ngInject';

            var self = this;
            //Constants
            $scope.dateRangeOptions = [{
                    label: gettextCatalog.getString('Days'),
                    value: 'day'
                }, {

                    label: gettextCatalog.getString('Weeks'),
                    value: 'week'
                },
                {
                    label: gettextCatalog.getString('Months'),
                    value: 'month'
                },
                {
                    label: gettextCatalog.getString('Years'),
                    value: 'year'
                }
            ];

            //Constants
            $scope.meterBasedOptions = [{
                    value: 'hour',
                    label: gettextCatalog.getString('Run Hours')

                }, {
                    value: 'miles',
                    label: gettextCatalog.getString('Miles')

                },
                {
                    label: gettextCatalog.getString('Kilometers'),
                    value: 'kilometers'
                }
            ];

            $scope.Meter = false;
            $scope.Calendar = true;
            $scope.$emit('disableMeter', {
                Meter: $scope.Meter
            });
            $scope.$emit('disableDate', {
                Calendar: $scope.Calendar
            });

            var getCalendarRules = function () {
                var result = [];

                if (!$scope.plan) {
                    result = [];
                }

                $scope.Calendar = false;
                for (var i = 0; i < $scope.plan.recurrence.rules.length; i++) {
                    if ($scope.plan.id) {
                        if ($scope.plan.recurrence.rules[i].type == "date") {
                            $scope.Calendar = true;
                            $scope.calendarDisabled = false;
                            result.push($scope.plan.recurrence.rules[i]);
                        }
                    }
                }

                if (!result || result.length <= 0) {
                    $scope.calendarDisabled = true;
                    $scope.Calendar = false;
                    result = [{
                        "type": "date",
                        "frequency": "month",
                        "interval": 3,
                        "upcoming": 2
                    }];

                }

                $scope.calendarRules = result;
            };

            var getMeterRules = function () {
                var result = [];

                if (!$scope.plan) result = [];

                if (!$scope.plan.id) {
                    $scope.meterDisabled = true;
                }

                $scope.Meter = false;
                for (var i = 0; i < $scope.plan.recurrence.rules.length; i++) {
                    if ($scope.plan.id) {
                        if ($scope.plan.recurrence.rules[i].type == "odometer" || $scope.plan.recurrence.rules[i].type == "runhour") {
                            $scope.Meter = true;
                            $scope.meterDisabled = false;
                        }
                    }
                    var rule = $scope.plan.recurrence.rules[i];

                    for (var j = 0; j < $scope.meterBasedOptions.length; j++) {

                        if (rule.frequency == $scope.meterBasedOptions[j].value) {
                            if (rule.frequency == "hour") {
                                rule.type = "runhour";
                            } else if (rule.frequency == "miles" || rule.frequency == "kilometers") {
                                rule.type = "odometer";
                            }
                            result.push(rule);
                        }
                    }
                }

                if (!result || result.length <= 0) {
                    $scope.meterDisabled = true;
                    $scope.Meter = false;
                    result = [{
                        "type": "runhour",
                        "frequency": "hour",
                        "interval": 1000,
                        "upcoming": 50
                    }];
                }
                $scope.meterRules = result;
            };

            self.refresh = function () {
                getMeterRules();
                getCalendarRules();
            };

            $scope.toggleFixed = function () {
                $scope.plan.recurrence.algorithm = "Fixed";
            };

            $scope.toggleOffset = function () {
                $scope.plan.recurrence.algorithm = "Offset";
            };

            $scope.$watch('plan', function (val) {
                if (val) self.refresh();
            });

            $scope.deleteRule = function (rule) {
                var index = $scope.plan.recurrence.rules.indexOf(rule);
                if (index >= 0) $scope.plan.recurrence.rules.splice(index, 1);
            };

            $scope.addAssetsButtonSelected = function () {

            };

            $scope.toggleMeterRules = function (check) {
                $scope.meterDisabled = !check;
                $scope.$emit('disableMeter', {
                    Meter: $scope.Meter
                });

            };

            $scope.toggleCalendarRules = function (check) {
                $scope.calendarDisabled = !check;
                $scope.$emit('disableDate', {
                    Calendar: $scope.Calendar,
                    CalendarRules: $scope.calendarRules
                });
            };

            $scope.$watch('meterRules', function (val) {
                $scope.$emit('meterRulesChange', {
                    MeterRules: $scope.meterRules
                });
            });

            $scope.$watch('calendarRules', function (val) {
                $scope.$emit('calendarRulesChange', {
                    CalendarRules: $scope.calendarRules
                });
            });
        }
    };
}
